import {Component, OnInit} from '@angular/core';
import {PageService} from '../../services/page.service';
import {UsuarioBc} from '../../model/usuario-bc';
import {AuthService} from '../../services/auth.service';
import {SolicitacoesService} from '../../services/solicitacoes.service';
import {CredenciaisService} from '../../services/credenciais.service';
import {ToastrService} from 'ngx-toastr';
import {SistemasService} from '../../services/sistemas.service';
import {StorageService} from '../../services/storage.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-gerenciar-credenciais',
  templateUrl: './gerenciar-credenciais.component.html',
  styleUrls: ['./gerenciar-credenciais.component.scss']
})
export class GerenciarCredenciaisComponent implements OnInit {

  mostrarSenha = false;
  showModalDetail = false;
  justify = '';
  carregandoPagina = true;
  usuarioLogado: UsuarioBc;
  solicitacoes: Array<any> = [];
  solicitacoesSelected: Array<any> = [];
  showModalSolicitarAcesso: boolean;
  showModalCadastroCredencial: boolean;
  tabSelecionada: any;
  config: any;
  solicitacaoCriarCredencial: any;
  solicitacaoAcessoProducao: any;

  carregando = true;
  filtros = [
    {
      id: '1',
      sigla: 'HMG',
      nome: 'Homologação',
      selecionado: true,
    },
    {
      id: '2',
      sigla: 'ANA',
      nome: 'Em análise para produção',
      selecionado: false,
    },
    {
      id: '3',
      sigla: 'PROD',
      nome: 'Produção',
      selecionado: false,
    },
  ];
  apps = [];

  constructor(
    private pageService: PageService,
    private authService: AuthService,
    private solicitacoesService: SolicitacoesService,
    private credenciaisService: CredenciaisService,
    private toast: ToastrService,
    private sistemasService: SistemasService,
    private storage: StorageService,
    private router: Router,
  ) {
  }

  async ngOnInit() {
    await this.carregarDados();
  }

  private async carregarDados() {
    console.log('tentando carregar os dados -- Gerenciar Credenciais');
    window.scrollTo({top: 0, behavior: 'smooth'});
    try {
      this.config = await this.pageService.get('paginaPrincipal');
      this.usuarioLogado = this.authService.getUsuarioLogado();
      const cpfSemFormatacao = this.usuarioLogado.cpf.trim().replace(/\D/gi, '');
      this.solicitacoes
        = await this.solicitacoesService.getSolicitacoesByUsuario(cpfSemFormatacao).toPromise();

      this.apps = await this.sistemasService.getBanners();
      this.solicitacoes = this.solicitacoes.filter((s) => {
        return s.portfolioSolicitado !== null;
      });
      this.carregandoPagina = false;
      this.tabSelecionada = this.filtros.filter((f) => {
        return f.selecionado;
      })[0];
      let imgs = {};
      for (let data of this.apps) {
        imgs[data.portifolio] = data.imagem.url;
      }
      this.solicitacoes.forEach(async (s: any) => {
        s.mostrarSenha = false;
        let qtdOperacoes = 0;
        const operacoes: Array<any> = [];
        operacoes[0] = {};
        operacoes[0].servicos = [];
        operacoes[1] = {};
        operacoes[1].servicos = [];

        s.imagem = imgs[s.portfolioSolicitado.idPortfolio];

        s.portfolioSolicitado.servicos.forEach((servico: any) => {
          qtdOperacoes = qtdOperacoes + servico.operacaoSolicitadas.length;
          const operacoesAprovadas = [];
          const operacoesReprovadas = [];
          servico.operacaoSolicitadas.forEach((o: any) => {
            if (o.stAprovado === 'S') {
              operacoesAprovadas.push(o);
            } else {
              operacoesReprovadas.push(o);
            }
          });
          if (operacoesAprovadas.length > 0) {
            operacoes[0].tipo = 'aprovadas';
            operacoes[0].nome = s.solicitacao.stSolicitacao === 'TESTADO_HOMOLOG' ? 'Operações' : 'Operações aprovadas';
            operacoes[0].servicos.push({noServico: servico.noServico, protocolos: operacoesAprovadas});
          }
          if (operacoesReprovadas.length > 0) {
            operacoes[1].tipo = 'naoAprovadas';
            operacoes[1].nome = s.solicitacao.stSolicitacao === 'TESTADO_HOMOLOG' ? 'Operações' : 'Operações não aprovadas';
            operacoes[1].servicos.push({noServico: servico.noServico, protocolos: operacoesReprovadas});
          }
        });
        let justify = await this.solicitacoesService.getJustify(s.solicitacao.idSolicitacao);
        if (justify && justify.length > 0) {
          justify = justify[justify.length - 1];
          if (justify.stAprovacao == "N") {
            s.justify = justify.dsJustificativaAprovacao;
          }
        }
        s.qtdOperacoes = qtdOperacoes;
        s.operacoes = operacoes;
      });
      await this.carregarSolicitacoes();
      this.carregando = false;
    } catch (e) {
      console.log(e);
      this.solicitacoesSelected = [];
      this.toast.error('Ocorreu um erro ao buscar as credenciais');
      this.carregando = false;
      this.carregandoPagina = false;
    }
  }

  async carregarSolicitacoes() {
    this.tabSelecionada = this.filtros.filter((f) => {
      return f.selecionado;
    })[0];
    if (this.tabSelecionada.sigla === 'HMG') {
      this.solicitacoesSelected = this.solicitacoes.filter((s: any) => {
        return s.solicitacao.stSolicitacao === 'TESTANDO_HOMOLOG' || s.solicitacao.stSolicitacao === 'DEFERIDA_PARCIALMENTE';
      });
      if (this.solicitacoesSelected.length > 0) {
        this.solicitacoesSelected.sort(this.orderDtEnvio);
        for (let i = 0; i < this.solicitacoesSelected.length; i++) {
          //this.solicitacoesSelected[i].accordion = i === 0;
          this.solicitacoesSelected[i].credencial
            = await this.credenciaisService.getCredenciaBySolicitacao(this.solicitacoesSelected[i].solicitacao.idSolicitacao).toPromise();
        }
      }
    } else if (this.tabSelecionada.sigla === 'ANA') {
      this.solicitacoesSelected = this.solicitacoes.filter((s: any) => {
        return s.solicitacao.stSolicitacao === 'TESTADO_HOMOLOG';
      });
      if (this.solicitacoesSelected.length > 0) {
        this.solicitacoesSelected.sort(this.orderDtEnvio);
        for (let i = 0; i < this.solicitacoesSelected.length; i++) {
          //this.solicitacoesSelected[i].accordion = i === 0;
          this.solicitacoesSelected[i].credencial
            = await this.credenciaisService.getCredenciaBySolicitacao(this.solicitacoesSelected[i].solicitacao.idSolicitacao).toPromise();
        }
      }
    } else if (this.tabSelecionada.sigla === 'PROD') {
      this.solicitacoesSelected = this.solicitacoes.filter((s: any) => {
        return s.solicitacao.stSolicitacao === 'TESTANDO_PRODUC';
      });
      if (this.solicitacoesSelected.length > 0) {
        this.solicitacoesSelected.sort(this.orderDtEnvio);
        for (let i = 0; i < this.solicitacoesSelected.length; i++) {
          //this.solicitacoesSelected[i].accordion = i === 0;
          this.solicitacoesSelected[i].credencial
            = await this.credenciaisService.getCredenciaBySolicitacao(this.solicitacoesSelected[i].solicitacao.idSolicitacao).toPromise();
        }
      }
    }
  }

  async selecionarFiltro(filtro: any) {
    // efeito visual do filtro
    for (let index = 0; index < this.filtros.length; index++) {
      this.filtros[index].selecionado = false;
    }
    filtro.selecionado = true;

    // fake loading
    this.carregando = true;
    await this.carregarSolicitacoes();
    this.carregando = false;
  }

  solicitarAcesso(app: any) {
    this.solicitacaoAcessoProducao = app;
    this.showModalSolicitarAcesso = true;
  }

  async fecharModalSolicitarAcesso(update: boolean) {
    this.showModalSolicitarAcesso = false;
    if (update) {
      this.carregandoPagina = true;
      this.carregando = true;
      await this.ngOnInit();
    }
  }

  cadastroCredencial(app: any) {
    this.solicitacaoCriarCredencial = app;
    this.showModalCadastroCredencial = true;
  }

  async fecharModalCadastroCredencial(update: boolean) {
    this.showModalCadastroCredencial = false;
    if (update) {
      this.carregando = true;
      await this.carregarSolicitacoes();
      this.carregando = false;
    }
  }

  orderDtEnvio(a, b) {
    if (a.solicitacao.dtEnvio > b.solicitacao.dtEnvio) {
      return -1;
    }
    if (a.solicitacao.dtEnvio < b.solicitacao.dtEnvio) {
      return 1;
    }
    return 0;
  }

  openJustify(justify) {
    this.justify = justify;
    this.showModalDetail = true;
  }

  fecharModaDetail() {
    this.showModalDetail = false;
  }

  async updateServico(app) {
    const appCurrent = this.apps.find(
      (data) => {
        return data.portifolio == app.portfolioSolicitado.idPortfolio;
      }
    );
    const dataApp = await this.credenciaisService.getCredenciaByService(app).toPromise();

    this.storage.setCurrentApp(JSON.stringify(appCurrent));
    localStorage.setItem("current-solicitacao", JSON.stringify(await this.dePara(dataApp, appCurrent)));
    localStorage.setItem("current-responsavel", JSON.stringify(await this.deParaReponse(dataApp.sistema)));
    await this.router.navigateByUrl("/solicitacao-de-acesso");
  }

  async dePara(dataApp, app) {
    return {
      update: true,
      sistema: {
        ...dataApp.sistema,
      },
      solicitante: dataApp.solicitante,
      stEstabelecimentoFilho: dataApp.stEstabelecimentoFilho,
      portfolioSolicitadoModel: {
        servicos: [],
        idPortfolioSolicitado: app.portifolio,
        idPortfolio: app.portifolio,
      },
      credencialModel: {
        dsCertificado: dataApp.credencial ? dataApp.credencial.dsCertificado : null,
        dtInsercao: dataApp.credencial ? dataApp.credencial.dtInsercao : null,
        nuCnpjCertificado: dataApp.credencial ? dataApp.credencial.nuCnpjCertificado : null,
        stRegistroAtivo: "S",
      },
      nuCnes: dataApp.nuCnes,
      id: dataApp.id,
      nuSolicitacao: dataApp.nuSolicitacao,
      nuAno: dataApp.nuAno,
      noUsuario: dataApp.noUsuario,
    };
  }

  async deParaReponse(solicitante) {
    return {
      sucesso: true,
      usuarioSUS: {
        ddTelefone: solicitante.operadorCadsus.nuDdd,
        email: solicitante.operadorCadsus.dsEmail,
        noOperadorCadsus: solicitante.operadorCadsus.nome,
        numTelefone: solicitante.operadorCadsus.nuDdd + solicitante.operadorCadsus.nuTelefone.toString(),
        numeroCNS: solicitante.operadorCadsus.nuCns,
        numeroCPF: solicitante.operadorCadsus.nuCpf,
      },
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/components/gerenciar-credenciais/gerenciar-credenciais.component.ts